<div [id]="id()" class="dashboard-table-section">
    <div class="section-header">
        <div class="header-left-section">
            <div class="header-icon-container">
                <i [class]="headerIcon()"></i>
            </div>
            <a
                [id]="id() + '-header-title'"
                [routerLink]="headerTitleLink().url"
                [queryParams]="headerTitleLink().queryParams"
                class="header-title"
                (click)="onHeaderTitleClick.emit()"
                >{{ headerTitle() | translate }}</a
            >
            <p-badge
                [id]="id + '-badge-number'"
                [value]="headerBadgeNumber().toString()"
                size="large"
                class="header-badge-number"></p-badge>
        </div>

        <a
            pButton
            class="button-link p-button-sm"
            [id]="id() + '-action-button'"
            [label]="headerButtonLabel() | translate"
            [routerLink]="headerButtonLink()"
            (click)="onActionButtonClick.emit()"></a>
    </div>
    <p-divider></p-divider>

    @if (description()) {
        <p class="description">{{ description() | translate }}</p>
    }

    @if (!isLoadingData()) {
        <div class="table-container" [class.hide-overflow]="!totalNumberOfItems() && !isLoadingData()">
            <ng-content select="[table]"></ng-content>
        </div>
    }
</div>

@if (isLoadingData()) {
    <app-loader></app-loader>
}
